import { z } from "zod";

export const SubjectType = {
  USER: "User",
  EVENT: "Event",
  ORGANIZATION: "Organization",

  EVENT_PARTICIPANT: "EventParticipant",
  PARTICIPANT: "EventParticipant", // Alias for backward compatibility
  INVITATION: "Invitation",
  OPEN_INVITATION: "OpenInvitation",
  REMINDER: "Reminder",

  EVENT_GROUPING: "EventGrouping",

  SUGGESTION_GENERATION_RUN: "ReasonGenerationRun",

  CUSTOM_FIELD_DEFINITION: "CustomFieldDefinition",

  MAGIC_LINK: "MagicLink",

  NOTIFICATION: "Notification",
  MESSAGE: "Message",

  SCHEDULED_TASK: "ScheduledTask",
  FEATURE_CONFIG: "FeatureConfig",

  USER_PROFILE: "UserProfile",

  QUEUE_ENTRY: "QueueEntry",

  CONNECTION_REQUEST: "ConnectionRequest",

  ENRICHMENT_REQUEST: "EnrichmentRequest",

  AI_MODEL_REQUEST: "AiModelRequest",

  SESSION: "Session",
} as const;

export type SubjectTypeType = (typeof SubjectType)[keyof typeof SubjectType];

export const SubjectTypeSchema = z.enum(SubjectType);
